module.exports = __webpack_public_path__ + "img/index_middle-03@2x.e982c836.png";